import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { ClienteService } from 'app/service/cliente/cliente.service';

import { GlobalHelpDialogComponent } from '../dialog/global-help-dialog/global-help-dialog.component';

export interface FormType {
  clientId: number;
  modelId: number;
  modelPrefix: string;
  primaryTypeId: number;
  file: File;
}

@Component({
  selector: "app-import-matriz",
  templateUrl: "./import-matriz.component.html",
  styleUrls: ["./import-matriz.component.scss"],
})
export class ImportMatrizComponent implements OnInit {
  public matrizForm: FormGroup;
  models: any[];
  selectedModel: {
    id: number;
    prefix: string;
  } = null;
  isLoading = true;
  selectedPrimaryType = null;
  nodesFiltered = [];
  nodesByModel: any[] = [];
  fileToUpload: File | null = null;
  fileType = "text/csv";
  fileChanging = false;
  fileHasError = false;
  fileIsCsv = false;
  clientId: number;
  isFileValidated = false;
  errorsList: {
    msg: string;
    line: number;
  }[] = [];
  clientName: String;

  constructor(
    private fb: FormBuilder,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private configPastaService: ConfigurarPastaServiceService,
    private clienteService: ClienteService,
  ) {
    this.listarModelos();
    this.route.params.subscribe(
      (params) => (this.clientId = params["clientId"])
    );
  }

  ngOnInit() {
    this.matrizForm = this.fb.group({
      alfrescoModel: [this.selectedModel, Validators.required],
      primaryTypeId: [this.selectedPrimaryType, Validators.required],
      file: [this.fileToUpload, Validators.required],
      clientId: [this.clientId, Validators.required],
    });

    this.getNomeEmpresa(this.clientId);
  }

  getNomeEmpresa(id) {
    this.clienteService.nomeCliente(id).subscribe(name => {
      this.clientName = name;
    }, err => {
      console.error(err);
      this.clientName = err.error.text;
    });
  }

  listarModelos() {
    this.configPastaService.getModelosAlfresco().subscribe(
      (dados) => {
        this.models = dados;

        if (dados.length === 0) {
          this.openSnackBar("Você não possui modelos vinculados", true);
        }
        this.isLoading = false;
      },
      (err) => {
        console.error(err);
        this.openSnackBar("Ocorreu um erro ao listar modelos", true);
        this.isLoading = false;
      }
    );
  }

  getExtension(filename: string) {
    return (
      filename.substring(filename.lastIndexOf(".") + 1, filename.length) ||
      filename
    );
  }

  handleForm() {
    if (this.matrizForm.valid) {
      this.isLoading = true;
      const formToSend: FormType = { ...this.matrizForm.value };

      formToSend.modelId = this.matrizForm.get("alfrescoModel").value.id;
      formToSend.modelPrefix =
        this.matrizForm.get("alfrescoModel").value.prefix;
      console.log(formToSend);

      //Validar arquivo
      if (!this.isFileValidated) {
        this.configPastaService
          .validateMatrizFile(formToSend, this.fileToUpload)
          .subscribe(
            (event) => {
              if (event instanceof HttpResponse) {
                this.isLoading = false;
                this.errorsList = event.body;

                if (this.errorsList.length === 0) {
                  this.isFileValidated = true;
                  this.fileHasError = false;
                } else {
                  this.fileHasError = true;
                  this.isFileValidated = false;
                }

                return this.openSnackBar(
                  "Validação do arquivo concluída!",
                  false
                );
              }
            },
            (err) => {
              this.isLoading = false;
              console.error(err);
              return this.openSnackBar(err.error.message, true);
            }
          );
      } else {
        //Importar arquivo
        this.configPastaService
          .sendMatrizFile(formToSend, this.fileToUpload)
          .subscribe(
            (event) => {
              if (event.type === HttpEventType.UploadProgress) {
                console.log("em andamento");
              } else if (event instanceof HttpResponse) {
                this.isLoading = false;
                this.isFileValidated = false;
                return this.openSnackBar(
                  "Importação realizada com sucesso !",
                  false
                );
              }
            },
            (err) => {
              this.isLoading = false;
              console.error(err);
              this.isFileValidated = false;
              return this.openSnackBar(err.error.message, true);
            }
          );
      }
    } else {
      return this.openSnackBar("Preencha os campos obrigatórios", true);
    }
  }

  handleFileInput(files: FileList) {
    this.isFileValidated = false;
    this.fileChanging = true;
    this.fileToUpload = files.item(0);
    const fileExtension = this.fileToUpload.type;

    this.fileIsCsv = fileExtension === this.fileType ? true : false;
    console.log(this.fileChanging, !this.fileIsCsv);
  }

  onSearchType(value: string) {
    const filter = value.toLowerCase();

    this.nodesFiltered = this.nodesByModel.filter((node) =>
      node.title
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .includes(filter)
    );
  }

  openHelpDialog(message: string, link?: string, isInternalLink?: boolean) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(GlobalHelpDialogComponent, {
      data: { message, link, isInternalLink },
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  listarNodesByModel(modelId: number) {
    this.configPastaService.getNodesByModelId(modelId).subscribe(
      (data) => {
        this.nodesByModel = data;
        this.nodesFiltered = [...data];
        if (data.length === 0) {
          this.openSnackBar("Este modelo não possui tipos documentais", true);
        } else {
          this.matrizForm.get("title").enable();
        }
      },

      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onModelSelectionChange() {
    console.log(this.matrizForm.get("alfrescoModel").value);
    this.selectedModel = this.matrizForm.get("alfrescoModel").value;

    this.listarNodesByModel(this.matrizForm.get("alfrescoModel").value.id);
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/import-matriz/import-matriz.component.ts